var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var HorizonIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 82,
    glyphHeight: 48,
    glyphOffsetY: 5,
    glyphOffsetX: 2
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6955 47.067L17.849 38.1939H64.0954L71.2743 47.0986C73.3578 44.9236 75.2093 42.5245 76.7889 39.9412L52.0891 9.33699H82C81.3402 6.23665 80.3376 3.26313 79.0339 0.457947H44.752H36.9701H2.96611C1.66235 3.26313 0.659796 6.23665 0 9.33699H29.8553L5.11072 39.7761C6.7045 42.4099 8.58002 44.8541 10.6955 47.067ZM49.6434 20.4358H32.301L25.1862 29.3148H56.7582L49.6434 20.4358ZM40.9722 9.78094L35.8584 15.9963H46.086L40.9722 9.78094Z",
    fill: "black"
  }));
};
export var HorizonIconGlyph = function (props) {
  return React.createElement(HorizonIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};